import classNames from "./CustomerStories.module.css";
import nacImg from "../../../assets/companies/nac.webp";
import Button from "../../common/Button";
import CompaniesSlider from "../landing/CompaniesSlider";
import { useCallback } from "react";
import mikeImg from "../../../assets/testimonies/mike.webp";
import ambrosettiImg from "../../../assets/companies/ambrosetti.svg";
import maurizioImg from "../../../assets/testimonies/maurizio.webp";
import icustomerImg from "../../../assets/companies/icustomer.webp";
import timImg from "../../../assets/testimonies/tim.webp";
import zachImg from "../../../assets/testimonies/landing/meetsmore.webp";
import meetsmoreImg from "../../../assets/companies/meetsmore.webp";
import yuvalImg from "../../../assets/testimonies/yuval.webp";
import forgeworksImg from "../../../assets/companies/forgeworks.webp";
import vitzImg from "../../../assets/testimonies/vitz.webp";
import knowledgeshareImg from "../../../assets/companies/knowledge_share.webp";
import federicoImg from "../../../assets/testimonies/federico.webp";
import { Link } from "react-router-dom";
import { useLogEvent } from "../../../hooks/log";

const stories = [
  {
    industry: "Manufacturing",
    companyImage: yuvalImg,
    quote:
      "Meetings that used to take twice as long because of manual translations are now much shorter. It saves us so much time and helps us collaborate much faster and more effectively.",
    image: yuvalImg,
    name: "Yuval",
    title: "AI Integration Manager at Filuet",
    company: "Filuet",
    link: "https://langfinity.ai/blog/how-filuet-collaborates-2x-faster-and-saves-50percent-meeting-time-with-langfinitys-seamless-translation-in-microsoft-teams-cm88azv29004mbkijp8op71r4/",
  },
  {
    industry: "Transportation",
    companyImage: forgeworksImg,
    quote:
      "What impressed me was Langfinity's ability to pick up cultural and linguistic nuances, even in complex languages like Catalan or Macedonian. It provides the right tone and formality depending on the context, which is critical in professional conversations.",
    image: vitzImg,
    name: "Vitz",
    title: "Co-Founder, Partner & Managing Director at ForgeWorks",
    company: "ForgeWorks",
    link: "https://langfinity.ai/blog/how-forgeworks-uses-langfinity-to-bridge-language-barriers-and-master-cultural-nuances-and-dialects-building-deeper-understanding-and-connection-in-client-communication-cm88ahbo6004lbkiju97cxna5/",
  },
  {
    industry: "Technology",
    companyImage: meetsmoreImg,
    quote:
      '"The translation quality was a massive jump from anything else we\'d tried", Zach explains. "We noticed right away that English <-> Japanese was just better, especially with our industry terms."',
    image: zachImg,
    name: "Zach",
    title: "MeetsMore",
    company: "MeetsMore",
    link: "https://langfinity.ai/blog/how-meetsmore-uses-langfinitys-accurate-domain-focused-translation-to-boost-team-engagement-and-collaboration-cm88bmrtv004nbkijwjzepfx7/",
  },
  {
    industry: "Research",
    companyImage: knowledgeshareImg,
    quote:
      "We really enjoyed the experience. The translation is 95% precise between Italian and English. The quality is impressive - fast and accurate.",
    image: federicoImg,
    name: "Federico",
    title: "PMO of Netval",
    company: "Knowledge Share",
    link: "https://langfinity.ai/blog/how-knowledge-share-delivers-95percent-accurate-real-time-interpretation-for-600-attendees-at-10x-cost-savings-clyby9iwj005iuj1ox8t045xl/",
  },
  {
    industry: "Financial services",
    companyImage: icustomerImg,
    quote:
      "With Langfinity, we didn't need to bend over backward to hire local talent before entering new markets. It gave us the confidence to scale into South America and beyond while saving significantly on operational costs.",
    image: timImg,
    name: "Tim",
    title: "Managing Director at iCustomer",
    company: "iCustomer",
    link: "https://langfinity.ai/blog/how-icustomer-achieved-rapid-and-efficient-expansion-into-south-america-with-langfinity-cm889o8h5004kbkijr7n9j4op/",
  },
  {
    industry: "Church",
    companyImage: nacImg,
    quote:
      "Langfinity was transformational for us. It made the impossible possible—allowing everyone at NAC to come together, communicate, and connect in their native languages. The translation was instant, accurate, and so natural that it felt like magic. It's not just a tool; it's a bridge that brought our community closer together, regardless of language.",
    image: mikeImg,
    name: "Mike",
    title: "Project Manager at the New Apostolic Church Canada",
    company: "NAC Canada",
    link: "https://langfinity.ai/blog/how-new-apostolic-church-canada-broke-down-language-barriers-with-90percent-accurate-ai-powered-real-time-translation-at-shine-their-largest-international-youth-summit-clzxc6za00077103aegp09avu/",
  },
  {
    industry: "Event",
    companyImage: ambrosettiImg,
    quote:
      "Before Langfinity, our search for interpreters was a time-consuming, expensive affair. Now, not only do we save on time and costs, but we also provide an inclusive experience for diverse voices to interact seamlessly. Langfinity's AI-powered translation technology enhances participant satisfaction,solidifying our stance as pioneers in embracing AI neural machine translation for comprehensive language inclusivity as an organization.",
    image: maurizioImg,
    name: "Maurizio",
    title: "Customer Obsession Circle Leader at The European House-Ambrosetti",
    company: "The European House-Ambrosetti",
    link: "https://langfinity.ai/blog/how-ambrosetti-boosted-engagement-and-satisfaction-with-90percent-accurate-real-time-voice-translation-and-10x-cost-savings-using-langfinity-cm88ccf47004pbkij0xvw0804/",
  },
  // {
  //   industry: "Manufacturing",
  //   companyImage: hycImg,
  //   quote:
  //     "With Langfinity's on-demand, 24/7 real-time translation, HY-C can now resolve critical product issues and clarify details in minutes during multilingual live conversations. This has significantly shortened their time-to-market, enabling faster iterations and more agile product launches.",
  //   company: "HY-C",
  //   link: "https://langfinity.ai/blog/how-hy-c-boosted-product-development-speed-and-efficiency-with-international-partners-through-langfinity-cm88ckg1l004qbkijmjhyk5i2/",
  // },
  // {
  //   industry: "NGO",
  //   companyImage: unescoImg,
  //   quote:
  //     "The success of Langfinity at UNESCO's i4T consultation highlights the immense potential of AI-powered multilingual tools in global conversations. These technologies go beyond solving language barriers—they empower diverse perspectives, foster inclusivity, and drive meaningful change. As the world becomes increasingly interconnected, tools like Langfinity pave the way for a future where communication knows no boundaries. By making every voice heard, Langfinity is not just transforming how we communicate—it's shaping how we collaborate, innovate, and connect as a global community",
  //   company: "UNESCO",
  //   link: "https://langfinity.ai/blog/transforming-multilingual-engagement-at-unescos-i4t-consultation-using-langfinity-ai-cm88c5qk6004obkiji86sn9p8/",
  // },
];

const CustomerStories = () => {
  const logEvent = useLogEvent();
  const clickGetADemo = useCallback(() => {
    logEvent({ type: "click_get_a_demo_customer_stories" });
    window.open("https://calendly.com/snow-huo-byrdhouse/30min", "_blank");
  }, [logEvent]);

  return (
    <div className={classNames.CustomerStories}>
      <h1>Industry-leading companies rely on Langfinity</h1>
      <h3>
        See why organizations trust Langfinity for multilingual communication
      </h3>

      <div className={classNames.Buttons}>
        <Button
          size="landing"
          color="white"
          backgroundColor="blue"
          borderColor="blue"
          onClick={() => scrollTo({ top: 600, behavior: "smooth" })}
        >
          See case studies
        </Button>
        <Button
          size="landing"
          color="black"
          backgroundColor="transparent"
          borderColor="black"
          onClick={clickGetADemo}
        >
          Get a demo
        </Button>
      </div>

      <CompaniesSlider />

      <div className={classNames.Cards}>
        {stories.map((story, i) => (
          <div key={i}>
            <div className={classNames.Industry}>{story.industry}</div>
            <img
              className={classNames.CompanyImg}
              src={story.companyImage}
              alt={story.company}
            />
            <h3>{story.company}</h3>
            <p>{story.quote}</p>
            <div className={classNames.Customer}>
              {story.image && <img src={story.image} alt={story.name} />}
              <div>
                <h3>{story.name}</h3>
                <h3>{story.title}</h3>
              </div>
            </div>
            <Link
              target="_blank"
              to={story.link}
              onClick={() => {
                logEvent({
                  type: "click_read_case_study",
                  details: { link: story.link },
                });
              }}
            >
              <Button color="white" borderColor="blue" backgroundColor="blue">
                Read case study
              </Button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomerStories;
